/**
 * 进度条指令
 * callback-调整进度之后的回调函数
 * author：Qian.qianchen 2018-11-03
 */
'use strict';
angular.module('audioProgressBarModule', []).
directive('audioProgressBar', ["$timeout", "$q", function($timeout, $q) {
    return {
        scope: {
            callback: "&",
            progressobj: "=",
            progressattr: "@",
            progressmax: "="
        },
        restrict: 'E',
        templateUrl: './resourceCenter/stock/audio/directive/audioProgressBar/audioProgressBar_tpl.html',
        link: function(scope, iElm, iAttrs, controller) {
            var contentHtml, btn, bar, start, end, step, g, b, m, max;
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                btn = iElm.find(".pointer")[0];
                bar = iElm.find(".content")[0];
                step = iElm.find(".progress")[0];
                g = document;
                b = window;
                m = Math;
                max = bar.offsetWidth - 10;
                if (scope.progressmax) {
                    setCurrent(scope.progressattr, scope.progressmax);
                } else {
                    scope.progressobj.addEventListener('canplay', function(e) {
                        scope.progressmax = scope.progressobj.duration;
                        audioPlayListener();
                    });
                }
                calcu(function(per) {
                    setAttr(per);
                });
            }
            /**
             * [calcu description] 拖动进度条
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function calcu(callback) {
                btn.onmousedown = function(e) { //按钮
                    var x = (e || b.event).clientX; // e 或者 window 的clientX （整体偏移）
                    var l = btn.offsetLeft; // 偏移距离
                    var max = bar.offsetWidth - btn.offsetWidth; //  最大偏移距离
                    var to = 0;
                    g.onmousemove = function(e) {
                        var thisX = (e || b.event).clientX; //整体偏移
                        to = m.min(max, m.max(0, l + (thisX - x)));
                        btn.style.left = to + 'px';
                        step.style.width = to + 'px';

                    };
                    g.onmouseup = function() {
                        g.onmousemove = null;
                        g.onmouseup = null;
                        callback(to);
                    };
                };
            }
            /**
             * [setAttr description] 属性值设置
             * @param {[type]} value [description] 属性值
             */
            function setAttr(value) {
                if (scope.progressattr == 'currentTime') {
                    scope.progressobj.removeEventListener("timeupdate", setAudioProgress, true);
                }

                if (value / max * scope.progressmax <= 0) {
                    scope.progressobj[scope.progressattr] = 0;
                } else if (value / max * scope.progressmax >= scope.progressmax) {
                    scope.progressobj[scope.progressattr] = scope.progressmax;
                } else {
                    scope.progressobj[scope.progressattr] = value / max * scope.progressmax;
                }
                if (scope.progressattr == 'currentTime') {
                    scope.progressobj.addEventListener("timeupdate", setAudioProgress, true);
                }

            }
            /**
             * [setCurrent description] 设置显示进度长度
             * @param {[type]} attr        [description] 设置属性
             * @param {[type]} progressMax [description] 进度条总长度
             */
            function setCurrent(attr, progressMax) {
                var current = scope.progressobj[attr];
                var width = 0;
                if (current * max / progressMax <= 0) {
                    width = 0;
                } else if (current * max / progressMax >= max) {
                    width = max;
                } else {
                    width = current * max / progressMax;
                }
                btn.style.left = width + 'px';
                step.style.width = width + 'px';
            }
            /**
             * [setAudioProgress description] 设置音频播放长度
             */
            function setAudioProgress() {
                setCurrent('currentTime', scope.progressmax);
            }
            /**
             * [audioPlayListener description] 音频播放时间更新监听
             * @return {[type]} [description]
             */
            function audioPlayListener() {
                scope.progressobj.addEventListener("timeupdate", setAudioProgress, true);
            }
        }
    }
}]);